const trTR= {
    login: {
      title: 'Oturum aç',
      sign_in_btn: 'Oturum aç'
    },
    bar: {
        logout: 'Oturumu kapat',
        languages: 'Diller',
        settings: 'Ayarları aç'
    },
    language: {
      name: 'Türkçe (Türkiye)',
    },
    attributePage: {
        title: 'Bilgi Değişiklikleri',
        viewChanges: 'Değişiklikleri Gör',
        dateTime: 'Tarih',
        notificationType: 'Bildirim Türü',
        notificationValue: 'Bildirim Değeri',
        oldValue: 'Eski Değer',
        newValue: 'Yeni Değer',
        accept: 'Kabul Et',
        reject: 'Reddet',
    },
    Home: 'Ana Sayfa',
    load: 'İlk yükleme gerçekleştiriliyor...',
    Requested: "İstendi",
    Viewed: "Görüntülendi",
    Executing: "Yürütülüyor",
    Completed: "Tamamlandı",
    Expired: "Süresi Doldu",
    Cancelled: "İptal Edildi",
    Error: "Hata",
    Rejected: "Reddedildi",
    error: 'Bir sorun oluştu; lütfen daha sonra tekrar deneyin.',
    displayname: 'Görünen Ad',
    givenname: 'Ad',
    surname: 'Soyadı',
    email: 'E-posta',
    mail: 'E-posta',
    name: 'Ad',
    firstname: 'Ad',
    lastname: 'Soyadı',
    footer_copyright: 'Tüm hakları saklıdır.'
  };
  
  export default trTR;
  